const empty = value => value == null || (typeof value === 'string' && !value.trim())

// Um separador decimal, sem agrupamento, expoente ou conversão parcial.
export function decimalNumber(value) {
  if (empty(value)) return null
  if (typeof value === 'number') return Number.isFinite(value) && Math.abs(value) <= Number.MAX_SAFE_INTEGER ? value : NaN
  if (typeof value !== 'string' || !/^-?(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(value.trim())) return NaN
  const number = Number(value.trim().replace(',', '.'))
  return Number.isFinite(number) && Math.abs(number) <= Number.MAX_SAFE_INTEGER ? number : NaN
}

export function decimalEdit(value, decimals, negative = false) {
  const raw = String(value ?? '').trim()
  if (!/^-?\d*(?:[.,]\d*)?$/.test(raw) || (!negative && raw.startsWith('-')) || (decimals === 0 && /[.,]/.test(raw))) return null
  const text = raw.replace('.', ','), [integer, fraction] = text.split(',')
  const normalized = integer.replace(/^(-?)0+(?=\d)/, '$1') + (fraction === undefined ? '' : ',' + fraction.slice(0, Math.max(0, decimals)))
  const partial = ['', '-', ',', '-,'].includes(normalized)
  const number = partial ? null : Number(normalized.replace(',', '.'))
  return number === null || (Number.isFinite(number) && Math.abs(number) <= Number.MAX_SAFE_INTEGER) ? { text: normalized, number } : null
}

export function decimalRule({ minimum = null, maximum = null, decimals = null } = {}) {
  return value => {
    if (empty(value)) return ''
    const number = decimalNumber(value)
    if (!Number.isFinite(number)) return 'Informe um número válido, com apenas vírgula ou ponto decimal, sem separadores de milhar.'
    if (minimum !== null && number < minimum) return 'Informe um valor maior ou igual a ' + String(minimum).replace('.', ',') + '.'
    if (maximum !== null && number > maximum) return 'Informe um valor menor ou igual a ' + String(maximum).replace('.', ',') + '.'
    if (decimals !== null && Math.abs(number - Number(number.toFixed(decimals))) > 1e-9) return 'Informe no máximo ' + decimals + ' casas decimais.'
    return ''
  }
}
